import { gql } from '@apollo/client'

import { WELLNESS_PLAN_FIELDS } from '../fragments'

export const UPDATE_AUTO_RENEWAL_WELLNESS_PLAN = gql`
  ${WELLNESS_PLAN_FIELDS}
  mutation UpdateAutoRenewalPlan($input: WPlanLogRenewalInput!) {
    updateAutoRenewalWellnessPlan(input: $input) {
      ...WellnessPlanFields
    }
  }
`
